import { FunctionComponent, useContext } from "react";
import styles from "./NotificationTopSection.module.css";
import { useMutation } from "@apollo/client";
import { CLEAR_ALL_NOTIFICATION } from "./api/NotificationQuery";
import { globalContext } from "../../../Provider/AppProvider";

interface NotificationProp{
   NotificationCount: number
   setClearNotifications:(value: boolean) => void
}

const NotificationTopSection: FunctionComponent<NotificationProp> = ({NotificationCount,setClearNotifications}) => {
  const {globalState, handleGlobalState} = useContext<any>(globalContext)
  const clearData = () =>{
    clearNotifications({});
  }

  const[clearNotifications] = useMutation(CLEAR_ALL_NOTIFICATION,{
    onCompleted:()=>{
      setClearNotifications(true);
      const tempData = {...globalState}
      tempData.notificationCount.recent = 0
      tempData.notificationCount.past = 0
      handleGlobalState(tempData)
    }
  })
  return (
    <div className={styles.notificationTopSection}>
      <div className={styles.title}>
        <b className={styles.notification6}>{`Notification (${NotificationCount})`}</b>
        {NotificationCount > 0 ? <div className={styles.clearAll} onClick={clearData}>Clear all</div> : ''}
      </div>
    </div>
  );
};

export default NotificationTopSection;
